import { useEffect } from "react";
import { api, API } from "../lib/api";

// Conta i secondi di utilizzo EFFETTIVO dell'app (mouse, tastiera, click, scroll)
// mentre la scheda è visibile, e li invia periodicamente al backend.
// Montato in Shell: attivo SOLO per gli utenti admin, su ogni pagina.
export default function ActivityTracker({ user }) {
  const enabled = !!user && user.role === "admin";

  useEffect(() => {
    if (!enabled) return undefined;

    const TICK = 5000; // valuta lo stato ogni 5s
    const IDLE = 60000; // "attivo" se c'è stato input negli ultimi 60s
    const FLUSH_EVERY = 30000; // invia al backend ogni 30s

    let lastActivity = Date.now();
    let accumMs = 0;

    const mark = () => { lastActivity = Date.now(); };
    const events = ["mousemove", "mousedown", "keydown", "scroll", "touchstart", "wheel", "click"];
    events.forEach((e) => window.addEventListener(e, mark, { passive: true }));

    const tick = setInterval(() => {
      const now = Date.now();
      if (!document.hidden && now - lastActivity <= IDLE) accumMs += TICK;
    }, TICK);

    const flush = (useBeacon = false) => {
      const secs = Math.round(accumMs / 1000);
      if (secs <= 0) return;
      accumMs = 0;
      try {
        if (useBeacon && navigator.sendBeacon) {
          const blob = new Blob([JSON.stringify({ seconds: secs })], { type: "application/json" });
          navigator.sendBeacon(`${API}/admin/activity/ping`, blob);
        } else {
          api.post("/admin/activity/ping", { seconds: secs }).catch(() => {});
        }
      } catch {
        /* ignora errori di rete transitori */
      }
    };

    const flushInt = setInterval(() => flush(false), FLUSH_EVERY);
    const onVis = () => { if (document.hidden) flush(false); };
    const onUnload = () => flush(true);
    document.addEventListener("visibilitychange", onVis);
    window.addEventListener("beforeunload", onUnload);

    return () => {
      events.forEach((e) => window.removeEventListener(e, mark));
      clearInterval(tick);
      clearInterval(flushInt);
      document.removeEventListener("visibilitychange", onVis);
      window.removeEventListener("beforeunload", onUnload);
      flush(false);
    };
  }, [enabled]);

  return null;
}
